import { css } from 'linaria';

export const carouselContainer = css`
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
`;

export const carouselTrack = css`
  display: flex;
  gap: var(--space-250);
  scroll-snap-type: x mandatory;
  padding: var(--space-125) 0;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    gap: var(--space-150);
  }
`;

export const projectCardWrapper = css`
  cursor: pointer;
`;

export const carouselButton = css`
  position: absolute !important;
  top: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
  border: var(--space-10) solid #ddd;
  box-shadow: var(--box-shadow-m);
  transform: translateY(-50%);
`;

export const carouselButtonLeft = css`
  left: var(--space-60);
`;

export const carouselButtonRight = css`
  right: var(--space-60);
`;

export const iconStyles = css`
  position: absolute;
  display: block;
  width: 9px !important;
  height: var(--space-175) !important;
  fill: var(--color-text);
`;

export const iconLeft = css`
  transform: translateX(-1px);
`;
